import { SprievodnyDokumentDownloadApi } from 'evidencna-aplikacia-frontend-ts-axios';
import apiConfiguration from '../../configuration/apiConfiguration';
import { evidenciaPrefixPath } from '../../configuration/apiConfigurationConstants';
import Uuid from '../../../model/Uuid';
import { ClientResponse } from '../../../model/ClientResponse';
import getFileName from '../../../function/getFileName';

const client = new SprievodnyDokumentDownloadApi(apiConfiguration(evidenciaPrefixPath));

interface ResponseType {
  fileName: string;
  blob: Blob;
}

export const downloadSprievodnyDokumentByUuid = async (
  uuid: Uuid,
  headers?: object,
): Promise<ClientResponse<Blob>> => {
  const {
    data,
    status,
  } = await client.downloadSprievodnyDokument(uuid, { ...headers, responseType: 'blob' });
  return {
    data: data && new Blob([data]),
    responseCode: status,
  };
};

export const downloadSprievodnyDokumentByTyp = async (
  materialUuid: Uuid,
  sprievodnyDokumentKod: string,
  stadiumHistoriaUuid?: string,
  headers?: object,
): Promise<ClientResponse<ResponseType>> => {
  const {
    data,
    status,
    headers: headersResponse,
  } = await client.downloadSprievodnyDokumentByTyp(
    materialUuid,
    sprievodnyDokumentKod,
    stadiumHistoriaUuid,
    { ...headers, responseType: 'blob' },
  );
  const blob = data && new Blob([data]);
  const fileName = getFileName(headersResponse);
  return {
    data: {
      fileName,
      blob,
    },
    responseCode: status,
  };
};
